import { FC, SVGProps } from "react";

export const StatusTiersIcon: FC<SVGProps<SVGSVGElement>> = ({
  fill = "white",
  className,
  width = 24,
  height = 24,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 6.5L13.9021 10.618H18.3148L14.7064 13.132L16.6085 17.25L12 14.736L7.39155 17.25L9.29366 13.132L5.68521 10.618H10.0979L12 6.5Z"
      />
    </svg>
  );
};
